module.exports = new __parcel__URL__("living-in-the-material-world.cdc72979.jpg").toString();